import PropTypes from 'prop-types';

export const StyleRuleConfigurationPropType = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  defaultValue: PropTypes.string,
  hierarchy: PropTypes.arrayOf(PropTypes.string),
  recipeName: PropTypes.string,
  type: PropTypes.string,
  typeDisplay: PropTypes.string,
  unit: PropTypes.string,
});

export const StyleRuleConfigurationsPropType = PropTypes.arrayOf(StyleRuleConfigurationPropType);
